import * as React from 'react';
import * as blocks from "./style.module.scss";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material';

const StyledAccordion = styled(Accordion)({
  boxShadow: "unset",
  backgroundColor: "unset",
  marginBottom: "30px",
  "&:last-child": {
    marginBottom: 0,
  },
  "&::before": {
    display: "none",
  },
  "@media (max-width: 600px)": {
    marginBottom: "20px",
  },
});

const StyledSummary = styled(AccordionSummary)({
  borderRadius: "20px",
  cursor: "pointer",
  padding: "30px",
  width: "100%",
  border: "none",
  textAlign: "left",
  outline: "none",
  fontSize: "15px",
  transition: "0.4s",
  color: '#F2E6FF',
  fontWeight: "400",
  position: "relative",
  "@media (max-width: 600px)": {
    padding: "20px",
  },
  "&:after": {
    content: "''",
    position: "absolute",
    top: "calc(50% - 19px)",
    right: "40px",
    width: "43px",
    height: "43px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    "@media (max-width: 600px)": {
      top: "20px",
      right: "20px",
      width: "30px",
      height: "30px",
    },
  },
  ".MuiAccordionSummary-content": {
    margin: 0,
    paddingRight: "70px",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 600px)": {
      paddingRight: "35px",
    }
  },
});

const StyledDetails = styled(AccordionDetails)({
  padding: "40px",
  backgroundColor: '#fff',
  overflow: "hidden",
  fontWeight: 300,
  fontSize: "18px",
  lineHeight: "21px",
  "@media (max-width: 600px)": {
    margin: "20px",
  },
  "p": {
    marginBottom: "20px",
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  "ul": {
    paddingLeft: "20px",
    marginTop: "20px"
  },
  "ul li": {
    listStyle: "disc",
  },
  "@media (max-width: 991px)": {
    padding: "20px",
  },
  "@media (max-width: 767px)": {
    padding: "10px",
  }
})

export const StructureBlocks = ({ data, blockType }) => { // blockType === maintenance or faq

  return (
    <div>
      {data.map((elem, index) => (
        <StyledAccordion disableGutters={true} key={index} square>
          <StyledSummary
            sx={{
              background: blockType === "faq" ?
                "linear-gradient(83.12deg, #FFE8DE .48%, #F2E8FF 100%)"
                :
                "linear-gradient(83.12deg, #9633FB 0.48%, #AC68FF 57.5%, #B881FF 100%)",
              "&:after": {
                backgroundImage: blockType === "faq" ?
                  "url(https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/faq-arrow-down.svg)"
                  :
                  "url(https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/arrow-down.svg)"
              },
              "&.Mui-expanded": {
                "&:after": {
                  backgroundImage: blockType === "faq" ?
                    "url(https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/faq-arrow-up.svg)"
                    :
                    "url(https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/arrow-up.svg)"
                }
              }
            }}
          >
            <div
              className={blocks.structure__blockHeaderTitle}
              style={{
                color: blockType === "faq" ? '#000' : '#fff'
              }}
            >
              {elem.title}
            </div>
          </StyledSummary>
          <StyledDetails>
            {elem.description}
          </StyledDetails>
        </StyledAccordion>
      ))}
    </div>
  );
};
